import React, { useEffect, useRef } from "react";
import "./TwitterWidget.css";

const TwitterWidget = () => {
  const tweetRef = useRef(null);

  useEffect(() => {
    const tweetId = "1871486485121437840"; // Your tweet ID

    // Ensure twttr is loaded and the ref exists
    if (window.twttr && window.twttr.widgets && tweetRef.current) {
      // Clear any previous content
      tweetRef.current.innerHTML = "";

      // Create tweet embed
      window.twttr.widgets
        .createTweet(tweetId, tweetRef.current, {
          theme: "light", // or "dark"
          align: "center",
        })
        .catch((err) => console.error("Tweet embed error:", err));
    }
  }, []);

  return (
    <div className="twitter-container">
      <div className="twitter-icon bg-secondary">twitter</div>

      <div className="twitter-embed">
        <div ref={tweetRef}></div>
      </div>
    </div>
  );
};

export default TwitterWidget;
